import { ContactListPage } from './components'
import { useContactList } from './hooks'

const ContactList = () => {
  const {
    webPageData: data,
    tableState,
    isFetching,
    filterForm,
    changePagination,
    DeleteConfirmation,
    startContactDelete
  } = useContactList()

  return (
    <ContactListPage
      webPageData={data}
      tableState={tableState}
      isFetching={isFetching}
      filterForm={filterForm}
      changePagination={changePagination}
      DeleteConfirmation={DeleteConfirmation}
      startContactDelete={startContactDelete}
    />
  )
}

export default ContactList
